<dx-popup
    #paymentEditorBox
    width="30%"
    height="75%"
    [title]="popupTitle"
    [showTitle]="true"
    [resizeEnabled]="true"
    [(visible)]="visible"
    (onHidden)="onHidden($event)"
>
    <div *dxTemplate="let item of 'content'" class="ar-payment-editor-content">
        <dx-box width="100%" height="100%" direction="col" *ngIf="!!paymentEditorData">
            <dxi-item [ratio]="1">
                <dx-form
                    #paymentEditorForm
                    width="100%"
                    height="100%"
                    [colCount]="1"
                    [(formData)]="paymentInfo"
                    [labelLocation]="defaultLabelLocation"
                >
                    <dxi-item *ngIf="!isAddPayment" [isRequired]="true">
                        <dxo-label text="Document Number"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box [(value)]="paymentInfo.documentNumber"></dx-text-box>
                        </div>
                    </dxi-item>
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Document Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box [(value)]="paymentInfo.documentDate" type="date"></dx-date-box>
                        </div>
                    </dxi-item>
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Post Date"></dxo-label>
                        <div *dxTemplate>
                            <dx-date-box
                                [min]="paymentEditorData.minPostDate"
                                [disabled]="!paymentEditorData.allowUpdatePostDate"
                                [(value)]="paymentInfo.postDate"
                                type="date"
                            ></dx-date-box>
                        </div>
                    </dxi-item>
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Payment Type"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                [searchEnabled]="true"
                                [dataSource]="paymentEditorData?.paymentTypes"
                                displayExpr="displayText"
                                valueExpr="key"
                                [(value)]="paymentInfo.paymentType"
                            ></dx-select-box>
                        </div>
                    </dxi-item>

                    <dxi-item [isRequired]="true" *ngIf="paymentEditorData.allowUpdateAmount">
                        <dxo-label text="Payment Amount"></dxo-label>
                        <div *dxTemplate>
                            <dx-number-box [format]="currencyFormat" [(value)]="paymentInfo.amount"></dx-number-box>
                        </div>
                    </dxi-item>
                    <dxi-item [isRequired]="true" *ngIf="isAddPayment">
                        <dxo-label text="Payment Description"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-box
                                placeholder="(e.g. Check Number)"
                                [(value)]="paymentInfo.paymentDescription"
                            ></dx-text-box>
                        </div>
                    </dxi-item>

                    <dxi-item>
                        <dxo-label text="Description"></dxo-label>
                        <div *dxTemplate>
                            <dx-text-area [height]="70" [(value)]="paymentInfo.description"></dx-text-area>
                        </div>
                    </dxi-item>
                    <dxi-item [isRequired]="true">
                        <dxo-label text="Sub Ledger"></dxo-label>
                        <div *dxTemplate>
                            <dx-select-box
                                [searchEnabled]="true"
                                [dataSource]="paymentEditorData?.subLedgers"
                                displayExpr="displayText"
                                valueExpr="key"
                                [disabled]="!paymentEditorData.allowUpdateSubLedger"
                                [(value)]="paymentInfo.subLedgerId"
                            ></dx-select-box>
                        </div>
                    </dxi-item>

                    <ng-container *ngIf="paymentEditorData.allowUpdateDimensions">
                        <ng-container *ngFor="let dimension of paymentEditorData.dimensions">
                            <dxi-item [isRequired]="dimension.required">
                                <dxo-label [text]="dimension.text"></dxo-label>
                                <div *dxTemplate>
                                    <dx-select-box
                                        displayExpr="text"
                                        valueExpr="code"
                                        [searchEnabled]="true"
                                        [dataSource]="dimension.options"
                                        [(value)]="paymentInfo[dimension.code]"
                                    ></dx-select-box>
                                </div>
                            </dxi-item>
                        </ng-container>
                    </ng-container>

                    <dxi-item [isRequired]="true" *ngIf="isAddPayment">
                        <dxo-label text="GL Account"></dxo-label>
                        <div *dxTemplate>
                            <app-multi-column-selector
                                [name]="'GL Account'"
                                [gridSource]="paymentEditorData?.glAccounts"
                                [boxValue]="glAccountNumbers"
                                [dropDownButtonTemplate]="'dropDownButton'"
                                [dropDownOptions]="{ width: 250 }"
                                [valueExpr]="'glAccountNumber'"
                                [displayExpr]="'displayText'"
                                [columnDef]="glAccountColumns"
                                [showClearButton]="true"
                                [placeholder]="'Select...'"
                                [disabled]="!paymentEditorData.allowUpdateGLAccountNumber"
                                (gridSelectionEvent)="onGlAccountNumberSelection($event)"
                            ></app-multi-column-selector>
                        </div>
                    </dxi-item>
                    <dxi-item isRequired="true" *ngIf="isAddPayment">
                        <dxo-label text="Offset GL Account"></dxo-label>
                        <div *dxTemplate>
                            <app-multi-column-selector
                                [name]="'GL Account'"
                                [gridSource]="paymentEditorData?.glAccounts"
                                [boxValue]="offsetGLAccountNumbers"
                                [dropDownButtonTemplate]="'dropDownButton'"
                                [dropDownOptions]="{ width: 250 }"
                                [valueExpr]="'glAccountNumber'"
                                [displayExpr]="'displayText'"
                                [columnDef]="glAccountColumns"
                                [showClearButton]="true"
                                [placeholder]="'Select...'"
                                (gridSelectionEvent)="onOffsetGlAccountNumberSelection($event)"
                            ></app-multi-column-selector>
                        </div>
                    </dxi-item>
                    <dxi-item *ngIf="isAddPayment">
                        <div *dxTemplate>Note: A/R Default Bank: {{ paymentEditorData.arDefaultBankName }}</div>
                    </dxi-item>
                </dx-form>
            </dxi-item>

            <dxi-item baseSize="auto">
                <dx-toolbar width="100%">
                    <dxi-item location="before">
                        <div *dxTemplate>
                            <dx-button
                                type="default"
                                text="Cancel"
                                [icon]="cancelIcon"
                                (onClick)="onHidden($event)"
                            ></dx-button>
                        </div>
                    </dxi-item>
                    <dxi-item location="after">
                        <div *dxTemplate>
                            <dx-button
                                type="success"
                                text="Save"
                                [icon]="saveIcon"
                                (onClick)="onSaveClick()"
                            ></dx-button>
                        </div>
                    </dxi-item>
                </dx-toolbar>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#paymentEditorBox' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
